import React, { Fragment } from 'react';
import { ChildMapRenderer } from '../components';

/**
 * ChildMap 渲染器 - 递归渲染对象数据
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 */
const ChildMapRenderer_ = ({ params, config }) => {
  let _params = params;
  if (config.firstField) {
    _params = params[config.firstField];
  }

  const keys = Object.keys(_params || {}).reverse();

  return (
    <>
      {_params && keys?.map((key, index) => {
        const _value = JSON.parse(JSON.stringify(_params[key]));

        if (key === 'RequestId' || config.ignoreKey?.includes(key)) {
          return <Fragment key={`empty-${index}`} />;
        }

        if (key === 'Type' && config.typeList?.length > 0) {
          return (
            <Fragment key={`type-${index}`}>
              <ChildMapRenderer
                keyName="Type"
                value={_value}
                dep={0}
                config={config.fieldsMap}
              />
            </Fragment>
          );
        }

        return (
          <Fragment key={`child-${index}`}>
            <ChildMapRenderer
              keyName={key}
              value={_value}
              dep={0}
              config={config.fieldsMap}
            />
          </Fragment>
        );
      })}
    </>
  );
};

export default ChildMapRenderer_;
